import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Typography.module.css';
export const Text = forwardRef(({ as: Component = 'p', size = 'base', weight = 'normal', color = 'default', align = 'left', className = '', children, ...props }, ref) => {
    // Normalize size aliases
    const normalizedSize = size === 'xs' || size === 'sm' ? 'small' : size === 'lg' ? 'large' : size;
    const classes = [
        styles.text,
        styles[`text${normalizedSize.charAt(0).toUpperCase() + normalizedSize.slice(1)}`],
        styles[`weight${weight.charAt(0).toUpperCase() + weight.slice(1)}`],
        styles[`color${color.charAt(0).toUpperCase() + color.slice(1)}`],
        styles[`align${align.charAt(0).toUpperCase() + align.slice(1)}`],
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx(Component, { ref: ref, className: classes, ...props, children: children }));
});
Text.displayName = 'Text';
